// deeply replace keys with a value of undefined with the firestore delete sigil

// do not clone some types, it messes them up
const canProcess = object => object !== null && (
	Object.getPrototypeOf(object).constructor.name === 'Object'
)

const undefinedToDeletes = firebase => (object) => {
	const newObject = { ...object }
	if (newObject) {
		Object.keys(newObject).forEach((key) => {
			if (newObject[key] === undefined) {
				newObject[key] = firebase.firestore.FieldValue.delete()
			} else if (canProcess(newObject[key])) {
				newObject[key] = undefinedToDeletes(firebase)(newObject[key])
			}
		})
	}
	return newObject
}

export default undefinedToDeletes



// WEBPACK FOOTER //
// ./src/utilities/Data/undefinedToDeletes/internal.js